import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getPaymentVoucherNumber(cookies, plantId, paymentDate) {
    const url = `${apiBaseUrl}/payment_vouchers/payment_voucher_number/?plant_id=${plantId}&payment_date=${paymentDate}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getPaymentVouchers(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/payment_vouchers/${query ? `?${query}` : ''}`).then((r) => r.data);
}

export async function getPaymentVoucherDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/payment_vouchers/${id}/`).then((r) => r.data);
}

export async function getDocumentsForPaymentVoucher(cookies, plantId, vendorId, excludePaymentId = '') {
    let url = `${apiBaseUrl}/payment_vouchers/documents_for_vendor/?plant_id=${plantId}&vendor_id=${vendorId}`;
    if (excludePaymentId) url += `&exclude_payment_id=${excludePaymentId}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getDocumentsForCustomerPaymentVoucher(cookies, plantId, customerId, excludePaymentId = '') {
    let url = `${apiBaseUrl}/payment_vouchers/documents_for_customer/?plant_id=${plantId}&customer_id=${customerId}`;
    if (excludePaymentId) url += `&exclude_payment_id=${excludePaymentId}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export function createPaymentVoucher(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/payment_vouchers/`, payload).then((r) => r.data);
}

export function cancelPaymentVoucher(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/payment_vouchers/${id}/`, {}).then((r) => r.data);
}

export function deletePaymentVoucher(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/payment_vouchers/${id}/`).then((r) => r.data);
}
